import { useRef } from 'react'
import lottie from 'lottie-web'
import {useEffect} from 'react'

export const LottieAnimation = (props) => {
  const container = useRef()

  useEffect(() => {
    const options = {
      container: container.current,
      renderer: 'svg',
      autoplay: false,
      loop: true,
      path: props.file,
    }
    const animation = lottie.loadAnimation(options)
    const mainLoop = () => {
      animation.playSegments([300, 900], true)
      animation.removeEventListener('loopComplete')
    }

    animation.playSegments([0, 300], true)
    animation.removeEventListener('loopComplete')
    animation.addEventListener('loopComplete', mainLoop)
  }, [])

  return <div ref={container} style={{height: '100%'}} />
}
